"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFabricWidgetObjectContainerStyles = exports.generateFabricWidgetElementContainerStyle = exports.generateElementContainerStyleWithoutTransform = exports.generateElementContainerStyle = void 0;
var fabric_1 = require("fabric");
var generateElementContainerStyle = function (object) {
    var scaleX = object.scaleX, scaleY = object.scaleY, left = object.left, top = object.top, width = object.width, height = object.height;
    var containerStyle = {
        position: 'absolute',
        userSelect: 'auto',
        pointerEvents: 'auto'
    };
    if (left !== undefined &&
        top !== undefined &&
        scaleX !== undefined &&
        scaleY !== undefined &&
        width !== undefined &&
        height !== undefined) {
        var padLeft = (width * scaleX - width) / 2;
        var padTop = (height * scaleY - height) / 2;
        containerStyle.width = "".concat(width, "px");
        containerStyle.height = "".concat(height, "px");
        containerStyle.left = "".concat(left + padLeft, "px");
        containerStyle.top = "".concat(top + padTop, "px");
        containerStyle.transform = "scale(".concat(scaleX, ", ").concat(scaleY, ")");
    }
    return containerStyle;
};
exports.generateElementContainerStyle = generateElementContainerStyle;
var generateElementContainerStyleWithoutTransform = function (object) {
    var scaleX = object.scaleX, scaleY = object.scaleY, left = object.left, top = object.top, width = object.width, height = object.height;
    var containerStyle = {
        position: 'absolute',
        userSelect: 'auto',
        pointerEvents: 'auto'
    };
    if (left !== undefined &&
        top !== undefined &&
        scaleX !== undefined &&
        scaleY !== undefined &&
        width !== undefined &&
        height !== undefined) {
        containerStyle.width = "".concat(width * scaleX, "px");
        containerStyle.height = "".concat(height * scaleY, "px");
        containerStyle.left = "".concat(left, "px");
        containerStyle.top = "".concat(top, "px");
    }
    return containerStyle;
};
exports.generateElementContainerStyleWithoutTransform = generateElementContainerStyleWithoutTransform;
/**
 * Generate styles without transform scale as it does not work with LG when video
 */
var generateFabricWidgetObjectContainerStyles = function (_a) {
    var canvas = _a.canvas, group = _a.group, _b = _a.scaleX, scaleX = _b === void 0 ? 1 : _b, _c = _a.scaleY, scaleY = _c === void 0 ? 1 : _c, _d = _a.width, width = _d === void 0 ? 100 : _d, _e = _a.height, height = _e === void 0 ? 100 : _e, _f = _a.left, left = _f === void 0 ? 0 : _f, _g = _a.top, top = _g === void 0 ? 0 : _g, _h = _a.angle, angle = _h === void 0 ? 0 : _h, _j = _a.editMode, editMode = _j === void 0 ? false : _j;
    var objectPoint = new fabric_1.fabric.Point(left, top);
    var groupPoint = group && fabric_1.fabric.util.transformPoint(objectPoint, group.calcTransformMatrix());
    var transformedPosition = fabric_1.fabric.util.transformPoint(groupPoint || objectPoint, canvas.viewportTransform || [1, 0, 0, 1, 0, 0]);
    var zoom = canvas.getZoom();
    return "transform: rotate(".concat(angle, "deg) scale(").concat(scaleX * zoom, ", ").concat(scaleY * zoom, ");\n          transform-origin: top left;\n          width: ").concat(width, "px;\n          height: ").concat(height, "px;\n          left: ").concat(transformedPosition.x, "px;\n          top: ").concat(transformedPosition.y, "px;\n          position: absolute;\n          user-select: ").concat(editMode ? 'auto' : 'none', ";\n          pointer-events: ").concat(editMode ? 'auto' : 'none', ";");
};
exports.generateFabricWidgetObjectContainerStyles = generateFabricWidgetObjectContainerStyles;
var generateFabricWidgetElementContainerStyle = function (workarea, object) {
    var scaleX = object.scaleX, scaleY = object.scaleY, _a = object.left, left = _a === void 0 ? 0 : _a, _b = object.top, top = _b === void 0 ? 0 : _b, width = object.width, height = object.height;
    var relativeTop = top - (workarea.top || 0);
    var relativeLeft = left - (workarea.left || 0);
    return {
        transform: "scale(".concat(scaleX, ", ").concat(scaleY, ")"),
        transformOrigin: 'top left',
        width: "".concat(width, "px"),
        height: "".concat(height, "px"),
        left: "".concat(relativeLeft, "px"),
        top: "".concat(relativeTop, "px"),
        position: 'absolute'
    };
};
exports.generateFabricWidgetElementContainerStyle = generateFabricWidgetElementContainerStyle;
//# sourceMappingURL=elementStyles.js.map